


// import React, { useRef, useState, useEffect } from 'react';
// import html2pdf from 'html2pdf.js';
// import axios from 'axios';

// const JobApplicationFormShareable = ({ onClose }) => {
//   const [formData, setFormData] = useState({
//     positionAppliedFor: '',
//     title: '',
//     surname: '',
//     firstName: '',
//     otherNames: '',
//     address: '',
//     email: '',
//     phoneNumber: '',
//     preferredContact: '',
//     unavailableDates: '',
//     eligibleNigeria: '',
//     eligibilityDocuments: '',
//     criminalConvictions: '',
//     unspentConvictionsDetails: '',
//     currentEmployerName: '',
//     currentEmployerAddress: '',
//     natureOfBusiness: '',
//     jobTitle: '',
//     dateJoined: '',
//     dateStartedCurrent: '',
//     noticePeriod: '',
//     currentSalary: '',
//     mainTasks: '',
//     reasonForLeaving: '',
//     employmentHistory: [
//       { employerName: '', employerAddress: '', businessType: '', dates: '', jobTitle: '', reasonForLeaving: '' }
//     ],
//     secondarySchool: '',
//     secondaryExams: '',
//     secondaryGrades: '',
//     furtherEducation: '',
//     professionalOrg: '',
//     gradeOfMembership: '',
//     jobTraining: '',
//     skillsInfo: '',
//     ref1Name: '',
//     ref1Company: '',
//     ref1Address: '',
//     ref1JobTitle: '',
//     ref1Relationship: '',
//     ref1Phone: '',
//     ref1Fax: '',
//     ref1Email: '',
//     ref2Name: '',
//     ref2Company: '',
//     ref2Address: '',
//     ref2JobTitle: '',
//     ref2Relationship: '',
//     ref2Phone: '',
//     ref2Fax: '',
//     ref2Email: '',
//     signature: '',
//     date: '',
//   });

//   const [whatsappNumber, setWhatsappNumber] = useState('');
//   const componentRef = useRef(null);
//   const [downloadCount, setDownloadCount] = useState(0);
//   const [isLoading, setIsLoading] = useState(true);


//    const requiredFields = [
//     'positionAppliedFor', 'title', 'surname', 'firstName', 'address', 'email', 'phoneNumber',
//     'preferredContact', 'eligibleNigeria', 'criminalConvictions', 'currentEmployerName',
//     'jobTitle', 'dateJoined', 'currentSalary', 'mainTasks', 'secondarySchool', 'secondaryExams',
//     'furtherEducation', 'skillsInfo', 'ref1Name', 'ref1Company', 'ref1JobTitle', 'ref1Phone',
//     'ref1Email', 'ref2Name', 'ref2Company', 'ref2JobTitle', 'ref2Phone', 'ref2Email',
//     'signature', 'date'
//   ];


//     const isFormComplete = requiredFields.every(field => 
//     formData[field] && formData[field].toString().trim() !== ""
//   );

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleEmploymentHistoryChange = (index, field, value) => {
//     const updatedHistory = formData.employmentHistory.map((item, i) =>
//       i === index ? { ...item, [field]: value } : item
//     );
//     setFormData(prev => ({ ...prev, employmentHistory: updatedHistory }));
//   };

//   const addEmploymentEntry = () => {
//     setFormData(prev => ({
//       ...prev,
//       employmentHistory: [...prev.employmentHistory, { employerName: '', employerAddress: '', businessType: '', dates: '', jobTitle: '', reasonForLeaving: '' }]
//     }));
//   };

//   const trackEvent = async (action) => {
//     try {
//       await axios.post(`${process.env.REACT_APP_API_URL}analytics/track-action`, {
//         action,
//         form: 'JobApplicationForm',
//         timestamp: new Date().toISOString(),
//       });
//       fetchDownloadCount();
//     } catch (error) {
//       console.error('Tracking error:', error);
//       const key = `jobForm_${action}_count`;
//       const currentCount = parseInt(localStorage.getItem(key) || '0', 10);
//       localStorage.setItem(key, currentCount + 1);
//       if (action === 'download') setDownloadCount(currentCount + 1);
//     }
//   };

//   const fetchDownloadCount = async () => {
//     setIsLoading(true);
//     try {
//       const response = await axios.get(`${process.env.REACT_APP_API_URL}analytics/form-analytics`);
//       setDownloadCount(response.data.downloadCount);
//     } catch (error) {
//       console.error('Error fetching download count:', error);
//       const localCount = parseInt(localStorage.getItem('jobForm_download_count') || '0', 10);
//       setDownloadCount(localCount);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchDownloadCount();
//   }, []);

//   const handleDownload = () => {
//      if (!isFormComplete) {
//       alert("Please fill all required fields before downloading");
//       return;
//     }
//     if (!componentRef.current) {
//       alert('Error: Form content is not available for download.');
//       return;
//     }
//     trackEvent('download');
//     const element = componentRef.current;
//     const opt = {
//       margin: 1,
//       filename: 'Job_Application_Form.pdf',
//       image: { type: 'jpeg', quality: 0.98 },
//       html2canvas: { scale: 2 },
//       jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
//     };
//     html2pdf().set(opt).from(element).save();
//   };

//   const handlePrint = () => {
//        if (!isFormComplete) {
//       alert("Please complete the form before printing");
//       return;
//     }
//     if (!componentRef.current) {
//       alert('Error: Nothing to print. Please try again.');
//       return;
//     }
//     trackEvent('print');
//     window.print();
//   };

//   const handleShare = async () => {
//      if (!isFormComplete) {
//       alert("Please fill all required fields before sharing");
//       return;
//     }
//     if (!navigator.share) {
//       alert('Web Share API is not supported in your browser. Please download the PDF and share it manually.');
//       return;
//     }
//     if (!componentRef.current) {
//       alert('Error: Form content is not available for sharing.');
//       return;
//     }
//     const element = componentRef.current;
//     const opt = {
//       margin: 1,
//       filename: 'Job_Application_Form.pdf',
//       image: { type: 'jpeg', quality: 0.98 },
//       html2canvas: { scale: 2 },
//       jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
//     };
//     try {
//       const pdfBlob = await html2pdf().set(opt).from(element).toPdf().output('blob');
//       const file = new File([pdfBlob], 'Job_Application_Form.pdf', { type: 'application/pdf' });
//       trackEvent('share');
//       await navigator.share({
//         title: 'Job Application Form',
//         text: 'Here is my completed job application form.',
//         files: [file],
//       });
//     } catch (error) {
//       console.error('Share error:', error);
//       alert('Failed to share the form. Please download and share manually.');
//     }
//   };

//   const handleSendToWhatsApp = () => {
//      if (!isFormComplete) {
//       alert("Please complete the form before sending");
//       return;
//     }
//     if (!whatsappNumber) {
//       alert('Please enter a valid WhatsApp number.');
//       return;
//     }
//     const cleanedNumber = whatsappNumber.replace(/\D/g, '');
//     const message = encodeURIComponent('Here is my job application form. Please find the PDF attached.');
//     const whatsappUrl = `https://wa.me/${cleanedNumber}?text=${message}`;
//     trackEvent('whatsapp');
//     alert('Please download the PDF first and attach it in WhatsApp after clicking OK.');
//     handleDownload();
//     window.open(whatsappUrl, '_blank');
//   };

//   return (
//     <div className="fixed inset-0 bg-gray-900 bg-opacity-60 flex items-center justify-center z-50 p-4">
//       <div className="bg-white rounded-xl shadow-2xl max-w-5xl w-full max-h-[90vh] overflow-y-auto p-8">
//         <div className="flex justify-between items-center mb-8">
//           <h1 className="text-3xl font-extrabold text-gray-900">Job Application Form</h1>
//           <button onClick={onClose} className="text-gray-500 hover:text-gray-700 text-2xl font-bold transition-colors">&times;</button>
//         </div>

//         {/* Action Buttons and Download Count */}
//         <div className="flex flex-wrap gap-4 mb-8 items-center">
//           <button
//             onClick={handlePrint}
//                disabled={!isFormComplete}
//         className={`font-medium py-2 px-6 rounded-lg transition-colors flex items-center gap-2 ${
//               isFormComplete 
//                 ? "bg-green-500 hover:bg-green-600 text-white" 
//                 : "bg-gray-300 text-gray-500 cursor-not-allowed"
//             }`}
//           >
//             Print Form
//           </button>
//           <button
//             onClick={handleDownload}
//             disabled={!isFormComplete}
//             className={`font-medium py-2 px-6 rounded-lg transition-colors flex items-center gap-2 ${
//               isFormComplete 
//                 ? "bg-blue-500 hover:bg-blue-600 text-white" 
//                 : "bg-gray-300 text-gray-500 cursor-not-allowed"
//             }`}
//           >
//             Download PDF
//           </button>
//           <button
//             onClick={handleShare}
//              disabled={!isFormComplete}
//             className={`font-medium py-2 px-6 rounded-lg transition-colors flex items-center gap-2 ${
//               isFormComplete 
//                 ? "bg-purple-500 hover:bg-purple-600 text-white" 
//                 : "bg-gray-300 text-gray-500 cursor-not-allowed"
//             }`}
//           >
//             Share Form
//           </button>
//           <div className="flex items-center gap-2">
//             <input
//               type="tel"
//               value={whatsappNumber}
//               onChange={(e) => setWhatsappNumber(e.target.value)}
//               placeholder="Enter WhatsApp Number"
//               className="p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//             <button
//               onClick={handleSendToWhatsApp}
//               disabled={!isFormComplete || !whatsappNumber}
//               className={`font-medium py-2 px-6 rounded-lg transition-colors flex items-center gap-2 ${
//                 isFormComplete && whatsappNumber
//                   ? "bg-teal-500 hover:bg-teal-600 text-white"
//                   : "bg-gray-300 text-gray-500 cursor-not-allowed"
//               }`}
//             >
//               Send to WhatsApp
//             </button>
//           </div>
//           <div className="ml-auto text-sm text-gray-500">
//             {isLoading ? 'Loading download count...' : `Downloads: ${downloadCount}`}
//           </div>
//         </div>
//            <div className="mb-6 p-4 rounded-lg bg-yellow-50 border border-yellow-300">
//           <p className="text-sm font-medium text-yellow-800">
//             {isFormComplete 
//               ? "✅ All required fields completed — You can now download/print/share!"
//               : `⚠️ Please fill all required fields (${requiredFields.length} total)`}
//           </p>
//         </div>

//         {/* Form Content */}
//         <div ref={componentRef} className="space-y-10">
//           {/* Position Applied For */}
//           <div className="border-b border-gray-200 pb-6">
//             <h2 className="text-xl font-semibold text-gray-800">Position Applied For</h2>
//             <input
//               type="text"
//               name="positionAppliedFor"
//               value={formData.positionAppliedFor}
//               onChange={handleInputChange}
//               className="mt-3 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//               placeholder="Enter position applied for"
//             />
//           </div>

//           {/* Personal Details */}
//           <div className="border-b border-gray-200 pb-6">
//             <h2 className="text-xl font-semibold text-gray-800">Personal Details</h2>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Title (Mr/Mrs/Miss/Ms)</label>
//                 <input
//                   type="text"
//                   name="title"
//                   value={formData.title}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Surname</label>
//                 <input
//                   type="text"
//                   name="surname"
//                   value={formData.surname}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">First Name(s)</label>
//                 <input
//                   type="text"
//                   name="firstName"
//                   value={formData.firstName}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Any Other Names</label>
//                 <input
//                   type="text"
//                   name="otherNames"
//                   value={formData.otherNames}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium text-gray-600">Address</label>
//                 <textarea
//                   name="address"
//                   value={formData.address}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   rows="3"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Email Address</label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Phone Number</label>
//                 <input
//                   type="tel"
//                   name="phoneNumber"
//                   value={formData.phoneNumber}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium text-gray-600">Preferred Contact Method</label>
//                 <input
//                   type="text"
//                   name="preferredContact"
//                   value={formData.preferredContact}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium text-gray-600">Dates Not Available for Interview</label>
//                 <textarea
//                   name="unavailableDates"
//                   value={formData.unavailableDates}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   rows="2"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Eligible for Employment in Nigeria?</label>
//                 <select
//                   name="eligibleNigeria"
//                   value={formData.eligibleNigeria}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 >
//                   <option value="">Select</option>
//                   <option value="YES">YES</option>
//                   <option value="NO">NO</option>
//                 </select>
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium text-gray-600">Documents for Eligibility</label>
//                 <textarea
//                   name="eligibilityDocuments"
//                   value={formData.eligibilityDocuments}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   rows="3"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Criminal Convictions (Unspent)?</label>
//                 <select
//                   name="criminalConvictions"
//                   value={formData.criminalConvictions}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 >
//                   <option value="">Select</option>
//                   <option value="YES">YES</option>
//                   <option value="NO">NO</option>
//                 </select>
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium text-gray-600">Details of Unspent Convictions</label>
//                 <textarea
//                   name="unspentConvictionsDetails"
//                   value={formData.unspentConvictionsDetails}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   rows="3"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Employment History (Current) */}
//           <div className="border-b border-gray-200 pb-6">
//             <h2 className="text-xl font-semibold text-gray-800">Employment History - Current/Previous Employer</h2>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Name of Company</label>
//                 <input
//                   type="text"
//                   name="currentEmployerName"
//                   value={formData.currentEmployerName}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium text-gray-600">Address</label>
//                 <textarea
//                   name="currentEmployerAddress"
//                   value={formData.currentEmployerAddress}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   rows="2"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Nature of Business</label>
//                 <input
//                   type="text"
//                   name="natureOfBusiness"
//                   value={formData.natureOfBusiness}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Job Title</label>
//                 <input
//                   type="text"
//                   name="jobTitle"
//                   value={formData.jobTitle}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Date Joined Organization</label>
//                 <input
//                   type="date"
//                   name="dateJoined"
//                   value={formData.dateJoined}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Date Started Current Position</label>
//                 <input
//                   type="date"
//                   name="dateStartedCurrent"
//                   value={formData.dateStartedCurrent}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Notice Period Required</label>
//                 <input
//                   type="text"
//                   name="noticePeriod"
//                   value={formData.noticePeriod}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Current Salary / Salary When Left</label>
//                 <input
//                   type="text"
//                   name="currentSalary"
//                   value={formData.currentSalary}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium text-gray-600">Main Tasks and Responsibilities</label>
//                 <textarea
//                   name="mainTasks"
//                   value={formData.mainTasks}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   rows="4"
//                 />
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium text-gray-600">Reason for Leaving (if no longer employed)</label>
//                 <textarea
//                   name="reasonForLeaving"
//                   value={formData.reasonForLeaving}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   rows="3"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Employment History Continued */}
//           <div className="border-b border-gray-200 pb-6">
//             <h2 className="text-xl font-semibold text-gray-800">Employment History (Continued)</h2>
//             <p className="text-sm text-gray-500 mb-4">List in chronological order, starting with most recent.</p>
//             {formData.employmentHistory.map((entry, index) => (
//               <div key={index} className="border border-gray-200 p-4 mb-4 rounded-lg bg-gray-50">
//                 <div className="grid grid-cols-1 md:grid-cols-6 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-600">Employer's Name & Address</label>
//                     <textarea
//                       value={entry.employerName + '\n' + entry.employerAddress}
//                       onChange={(e) => handleEmploymentHistoryChange(index, 'employerName', e.target.value.split('\n')[0])}
//                       className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                       rows="2"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-600">Type of Business</label>
//                     <input
//                       type="text"
//                       value={entry.businessType}
//                       onChange={(e) => handleEmploymentHistoryChange(index, 'businessType', e.target.value)}
//                       className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-600">Dates of Employment</label>
//                     <input
//                       type="text"
//                       value={entry.dates}
//                       onChange={(e) => handleEmploymentHistoryChange(index, 'dates', e.target.value)}
//                       className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-600">Job Title/Role</label>
//                     <input
//                       type="text"
//                       value={entry.jobTitle}
//                       onChange={(e) => handleEmploymentHistoryChange(index, 'jobTitle', e.target.value)}
//                       className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     />
//                   </div>
//                   <div className="md:col-span-2">
//                     <label className="block text-sm font-medium text-gray-600">Reason for Leaving</label>
//                     <textarea
//                       value={entry.reasonForLeaving}
//                       onChange={(e) => handleEmploymentHistoryChange(index, 'reasonForLeaving', e.target.value)}
//                       className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                       rows="2"
//                     />
//                   </div>
//                 </div>
//               </div>
//             ))}
//             <button
//               type="button"
//               onClick={addEmploymentEntry}
//               className="bg-gray-600 hover:bg-gray-700 text-white font-medium py-2 px-4 rounded-lg transition-colors"
//             >
//               Add Another Entry
//             </button>
//           </div>

//           {/* Education and Training */}
//           <div className="border-b border-gray-200 pb-6">
//             <h2 className="text-xl font-semibold text-gray-800">Education and Training</h2>
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Secondary School Attended</label>
//                 <input
//                   type="text"
//                   name="secondarySchool"
//                   value={formData.secondarySchool}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Examinations Passed</label>
//                 <input
//                   type="text"
//                   name="secondaryExams"
//                   value={formData.secondaryExams}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Grades</label>
//                 <input
//                   type="text"
//                   name="secondaryGrades"
//                   value={formData.secondaryGrades}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div className="md:col-span-3">
//                 <label className="block text-sm font-medium text-gray-600">Further and Higher Education</label>
//                 <textarea
//                   name="furtherEducation"
//                   value={formData.furtherEducation}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   rows="3"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Professional Organization</label>
//                 <input
//                   type="text"
//                   name="professionalOrg"
//                   value={formData.professionalOrg}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Grade of Membership</label>
//                 <input
//                   type="text"
//                   name="gradeOfMembership"
//                   value={formData.gradeOfMembership}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div className="md:col-span-3">
//                 <label className="block text-sm font-medium text-gray-600">Job-Related Training</label>
//                 <textarea
//                   name="jobTraining"
//                   value={formData.jobTraining}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   rows="4"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Skills, Abilities */}
//           <div className="border-b border-gray-200 pb-6">
//             <h2 className="text-xl font-semibold text-gray-800">Skills, Abilities and Supporting Information</h2>
//             <div className="mt-4">
//               <textarea
//                 name="skillsInfo"
//                 value={formData.skillsInfo}
//                 onChange={handleInputChange}
//                 className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 rows="6"
//                 placeholder="Provide evidence of skills, knowledge, and experience..."
//               />
//             </div>
//           </div>

//           {/* References */}
//           <div className="border-b border-gray-200 pb-6">
//             <h2 className="text-xl font-semibold text-gray-800">References</h2>
//             <p className="text-sm text-gray-500 mb-4">Provide details of two referees.</p>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//               <div>
//                 <h3 className="font-medium text-gray-700 mb-2">Referee 1</h3>
//                 <div className="space-y-3">
//                   <input
//                     type="text"
//                     name="ref1Name"
//                     value={formData.ref1Name}
//                     onChange={handleInputChange}
//                     placeholder="Name"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <input
//                     type="text"
//                     name="ref1Company"
//                     value={formData.ref1Company}
//                     onChange={handleInputChange}
//                     placeholder="Company Name"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <textarea
//                     name="ref1Address"
//                     value={formData.ref1Address}
//                     onChange={handleInputChange}
//                     placeholder="Full Address"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     rows="2"
//                   />
//                   <input
//                     type="text"
//                     name="ref1JobTitle"
//                     value={formData.ref1JobTitle}
//                     onChange={handleInputChange}
//                     placeholder="Job Title"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <input
//                     type="text"
//                     name="ref1Relationship"
//                     value={formData.ref1Relationship}
//                     onChange={handleInputChange}
//                     placeholder="Nature of Relationship"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <input
//                     type="tel"
//                     name="ref1Phone"
//                     value={formData.ref1Phone}
//                     onChange={handleInputChange}
//                     placeholder="Phone"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <input
//                     type="text"
//                     name="ref1Fax"
//                     value={formData.ref1Fax}
//                     onChange={handleInputChange}
//                     placeholder="Fax"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <input
//                     type="email"
//                     name="ref1Email"
//                     value={formData.ref1Email}
//                     onChange={handleInputChange}
//                     placeholder="Email"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                 </div>
//               </div>
//               <div>
//                 <h3 className="font-medium text-gray-700 mb-2">Referee 2</h3>
//                 <div className="space-y-3">
//                   <input
//                     type="text"
//                     name="ref2Name"
//                     value={formData.ref2Name}
//                     onChange={handleInputChange}
//                     placeholder="Name"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <input
//                     type="text"
//                     name="ref2Company"
//                     value={formData.ref2Company}
//                     onChange={handleInputChange}
//                     placeholder="Company Name"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <textarea
//                     name="ref2Address"
//                     value={formData.ref2Address}
//                     onChange={handleInputChange}
//                     placeholder="Full Address"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     rows="2"
//                   />
//                   <input
//                     type="text"
//                     name="ref2JobTitle"
//                     value={formData.ref2JobTitle}
//                     onChange={handleInputChange}
//                     placeholder="Job Title"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <input
//                     type="text"
//                     name="ref2Relationship"
//                     value={formData.ref2Relationship}
//                     onChange={handleInputChange}
//                     placeholder="Nature of Relationship"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <input
//                     type="tel"
//                     name="ref2Phone"
//                     value={formData.ref2Phone}
//                     onChange={handleInputChange}
//                     placeholder="Phone"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <input
//                     type="text"
//                     name="ref2Fax"
//                     value={formData.ref2Fax}
//                     onChange={handleInputChange}
//                     placeholder="Fax"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <input
//                     type="email"
//                     name="ref2Email"
//                     value={formData.ref2Email}
//                     onChange={handleInputChange}
//                     placeholder="Email"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                 </div>
//               </div>
//             </div>
//             <p className="text-sm text-gray-500 mt-4 italic">Note: We will only contact referees with your prior agreement.</p>
//           </div>

//           {/* Personal Declaration */}
//           <div className="border-b border-gray-200 pb-6">
//             <h2 className="text-xl font-semibold text-gray-800">Personal Declaration</h2>
//             <p className="text-sm text-gray-600 mt-4 mb-4">
//               I confirm that, to the best of my knowledge, all the details I have given on this form are complete and true. I understand that if I give any false or misleading information, and/or I am unable to provide specifically requested details (of qualifications etc), it may lead to my dismissal (if I have already been given the job). I understand that any job offer depends on the supply of satisfactory references, evidence that I am eligible to work in Nigeria and sight of original certificates, as detailed in my application.
//             </p>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Signature</label>
//                 <input
//                   type="text"
//                   name="signature"
//                   value={formData.signature}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Date</label>
//                 <input
//                   type="date"
//                   name="date"
//                   value={formData.date}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Print Styles */}
//         <style jsx global>{`
//           @media print {
//             body * { visibility: hidden; }
//             .fixed, button, input[type="tel"] { display: none !important; }
//             div[ref="componentRef"] * { visibility: visible; }
//             div[ref="componentRef"] { position: absolute; left: 0; top: 0; width: 100%; }
//             .border-b { border-bottom: 1px solid #e5e7eb !important; }
//             .bg-gray-50 { background: none !important; }
//             input, textarea, select { border: 1px solid #d1d5db !important; background: none !important; }
//           }
//         `}</style>
//       </div>
//     </div>
//   );
// };

// export default JobApplicationFormShareable;























































import React, { useRef, useState, useEffect } from 'react';
import html2pdf from 'html2pdf.js';
import axios from 'axios';

// ─── Printable Document (rendered off-screen, captured as PDF) ───────────────
const PrintableForm = React.forwardRef(({ formData }, ref) => {
  const field = (label, value, full = false) => (
    <div style={{ marginBottom: 10, width: full ? '100%' : 'auto', pageBreakInside: 'avoid' }}>
      <div style={{ fontSize: 9, fontWeight: 700, color: '#555', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 2 }}>{label}</div>
      <div style={{
        minHeight: 22, borderBottom: '1px solid #333', padding: '3px 2px',
        fontSize: 11, color: '#111', wordBreak: 'break-word', whiteSpace: 'pre-wrap'
      }}>{value || ' '}</div>
    </div>
  );

  const sectionTitle = (title) => (
    <div style={{
      background: '#1a1a2e', color: '#fff', padding: '5px 10px',
      fontSize: 11, fontWeight: 700, letterSpacing: '0.5px',
      marginTop: 16, marginBottom: 8, pageBreakAfter: 'avoid'
    }}>{title}</div>
  );

  const row = (children, cols = 2) => (
    <div style={{ display: 'grid', gridTemplateColumns: `repeat(${cols}, 1fr)`, gap: '0 16px' }}>
      {children}
    </div>
  );

  return (
    <div ref={ref} style={{
      fontFamily: 'Arial, Helvetica, sans-serif',
      fontSize: 11, color: '#111',
      padding: '20px 28px',
      maxWidth: '750px',
      margin: '0 auto',
      background: '#fff',
    }}>
      {/* Header */}
      <div style={{ textAlign: 'center', marginBottom: 16, borderBottom: '2px solid #1a1a2e', paddingBottom: 10 }}>
        <div style={{ fontSize: 18, fontWeight: 800, color: '#1a1a2e', letterSpacing: '1px' }}>JOB APPLICATION FORM</div>
        <div style={{ fontSize: 10, color: '#666', marginTop: 2 }}>All information provided will be treated in strict confidence</div>
      </div>

      {field('Position Applied For', formData.positionAppliedFor, true)}

      {sectionTitle('PERSONAL DETAILS')}
      {row([
        field('Title (Mr/Mrs/Miss/Ms)', formData.title),
        field('Surname', formData.surname),
        field('First Name(s)', formData.firstName),
        field('Other Names', formData.otherNames),
      ])}
      {field('Address', formData.address, true)}
      {row([
        field('Email Address', formData.email),
        field('Phone Number', formData.phoneNumber),
        field('Preferred Contact Method', formData.preferredContact),
        field('Dates Not Available for Interview', formData.unavailableDates),
        field('Eligible for Employment in Nigeria?', formData.eligibleNigeria),
        field('Criminal Convictions (Unspent)?', formData.criminalConvictions),
      ])}
      {field('Documents for Eligibility', formData.eligibilityDocuments, true)}
      {field('Details of Unspent Convictions', formData.unspentConvictionsDetails, true)}

      {sectionTitle('CURRENT / PREVIOUS EMPLOYMENT')}
      {row([
        field('Company Name', formData.currentEmployerName),
        field('Nature of Business', formData.natureOfBusiness),
        field('Job Title', formData.jobTitle),
        field('Notice Period', formData.noticePeriod),
        field('Date Joined Organisation', formData.dateJoined),
        field('Date Started Current Position', formData.dateStartedCurrent),
        field('Current Salary / Salary When Left', formData.currentSalary),
      ])}
      {field('Employer Address', formData.currentEmployerAddress, true)}
      {field('Main Tasks and Responsibilities', formData.mainTasks, true)}
      {field('Reason for Leaving (if applicable)', formData.reasonForLeaving, true)}

      {sectionTitle('EMPLOYMENT HISTORY (most recent first)')}
      <div style={{ pageBreakInside: 'avoid' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '2fr 1.2fr 1.2fr 1.2fr 1.5fr',
          gap: '0 8px',
          fontSize: 9, fontWeight: 700, textTransform: 'uppercase',
          borderBottom: '1px solid #999', paddingBottom: 3, marginBottom: 4
        }}>
          {['Employer Name & Address', 'Type of Business', 'Dates', 'Job Title', 'Reason for Leaving'].map(h => (
            <div key={h}>{h}</div>
          ))}
        </div>
        {formData.employmentHistory.map((e, i) => (
          <div key={i} style={{
            display: 'grid',
            gridTemplateColumns: '2fr 1.2fr 1.2fr 1.2fr 1.5fr',
            gap: '0 8px',
            borderBottom: '1px solid #eee',
            paddingBottom: 4, marginBottom: 4, fontSize: 10
          }}>
            <div style={{ wordBreak: 'break-word' }}>{e.employerName}{e.employerAddress ? '\n' + e.employerAddress : ''}</div>
            <div>{e.businessType}</div>
            <div>{e.dates}</div>
            <div>{e.jobTitle}</div>
            <div style={{ wordBreak: 'break-word' }}>{e.reasonForLeaving}</div>
          </div>
        ))}
      </div>

      {sectionTitle('EDUCATION AND TRAINING')}
      {row([
        field('Secondary School Attended', formData.secondarySchool),
        field('Examinations Passed', formData.secondaryExams),
        field('Grades', formData.secondaryGrades),
        field('Professional Organisation', formData.professionalOrg),
        field('Grade of Membership', formData.gradeOfMembership),
      ])}
      {field('Further and Higher Education', formData.furtherEducation, true)}
      {field('Job-Related Training', formData.jobTraining, true)}

      {sectionTitle('SKILLS, ABILITIES AND SUPPORTING INFORMATION')}
      {field('', formData.skillsInfo, true)}

      {sectionTitle('REFERENCES')}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 24px' }}>
        <div>
          <div style={{ fontWeight: 700, fontSize: 10, marginBottom: 6 }}>Referee 1</div>
          {field('Name', formData.ref1Name, true)}
          {field('Company', formData.ref1Company, true)}
          {field('Address', formData.ref1Address, true)}
          {field('Job Title', formData.ref1JobTitle, true)}
          {field('Relationship', formData.ref1Relationship, true)}
          {row([
            field('Phone', formData.ref1Phone),
            field('Email', formData.ref1Email),
          ])}
        </div>
        <div>
          <div style={{ fontWeight: 700, fontSize: 10, marginBottom: 6 }}>Referee 2</div>
          {field('Name', formData.ref2Name, true)}
          {field('Company', formData.ref2Company, true)}
          {field('Address', formData.ref2Address, true)}
          {field('Job Title', formData.ref2JobTitle, true)}
          {field('Relationship', formData.ref2Relationship, true)}
          {row([
            field('Phone', formData.ref2Phone),
            field('Email', formData.ref2Email),
          ])}
        </div>
      </div>
      <div style={{ fontSize: 9, color: '#777', marginTop: 4, fontStyle: 'italic' }}>
        Note: We will only contact referees with your prior agreement.
      </div>

      {sectionTitle('PERSONAL DECLARATION')}
      <div style={{ fontSize: 9.5, color: '#333', lineHeight: 1.5, marginBottom: 10 }}>
        I confirm that, to the best of my knowledge, all the details I have given on this form are complete and true.
        I understand that if I give any false or misleading information, and/or I am unable to provide specifically
        requested details (of qualifications etc), it may lead to my dismissal (if I have already been given the job).
        I understand that any job offer depends on the supply of satisfactory references, evidence that I am eligible
        to work in Nigeria and sight of original certificates, as detailed in my application.
      </div>
      {row([
        field('Signature', formData.signature),
        field('Date', formData.date),
      ])}
    </div>
  );
});

// ─── Main Component ──────────────────────────────────────────────────────────
const JobApplicationFormShareable = ({ onClose }) => {
  const [formData, setFormData] = useState({
    positionAppliedFor: '', title: '', surname: '', firstName: '', otherNames: '',
    address: '', email: '', phoneNumber: '', preferredContact: '', unavailableDates: '',
    eligibleNigeria: '', eligibilityDocuments: '', criminalConvictions: '',
    unspentConvictionsDetails: '', currentEmployerName: '', currentEmployerAddress: '',
    natureOfBusiness: '', jobTitle: '', dateJoined: '', dateStartedCurrent: '',
    noticePeriod: '', currentSalary: '', mainTasks: '', reasonForLeaving: '',
    employmentHistory: [
      { employerName: '', employerAddress: '', businessType: '', dates: '', jobTitle: '', reasonForLeaving: '' }
    ],
    secondarySchool: '', secondaryExams: '', secondaryGrades: '', furtherEducation: '',
    professionalOrg: '', gradeOfMembership: '', jobTraining: '', skillsInfo: '',
    ref1Name: '', ref1Company: '', ref1Address: '', ref1JobTitle: '', ref1Relationship: '',
    ref1Phone: '', ref1Fax: '', ref1Email: '',
    ref2Name: '', ref2Company: '', ref2Address: '', ref2JobTitle: '', ref2Relationship: '',
    ref2Phone: '', ref2Fax: '', ref2Email: '',
    signature: '', date: '',
  });

  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [downloadCount, setDownloadCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isGenerating, setIsGenerating] = useState(false);
  const printableRef = useRef(null);

  const requiredFields = [
    'positionAppliedFor', 'title', 'surname', 'firstName', 'address', 'email', 'phoneNumber',
    'preferredContact', 'eligibleNigeria', 'criminalConvictions', 'currentEmployerName',
    'jobTitle', 'dateJoined', 'currentSalary', 'mainTasks', 'secondarySchool', 'secondaryExams',
    'furtherEducation', 'skillsInfo', 'ref1Name', 'ref1Company', 'ref1JobTitle', 'ref1Phone',
    'ref1Email', 'ref2Name', 'ref2Company', 'ref2JobTitle', 'ref2Phone', 'ref2Email',
    'signature', 'date'
  ];

  const missingFields = requiredFields.filter(f => !formData[f] || formData[f].toString().trim() === '');
  const isFormComplete = missingFields.length === 0;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleEmploymentHistoryChange = (index, field, value) => {
    setFormData(prev => ({
      ...prev,
      employmentHistory: prev.employmentHistory.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      )
    }));
  };

  const addEmploymentEntry = () => {
    setFormData(prev => ({
      ...prev,
      employmentHistory: [...prev.employmentHistory, {
        employerName: '', employerAddress: '', businessType: '', dates: '', jobTitle: '', reasonForLeaving: ''
      }]
    }));
  };

  const getPdfOptions = () => ({
    margin: [10, 10, 10, 10],
    filename: 'Job_Application_Form.pdf',
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { scale: 2, useCORS: true, logging: false, scrollY: 0 },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
  });

  const trackEvent = async (action) => {
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}analytics/track-action`, {
        action, form: 'JobApplicationForm', timestamp: new Date().toISOString(),
      });
      fetchDownloadCount();
    } catch {
      const key = `jobForm_${action}_count`;
      const count = parseInt(localStorage.getItem(key) || '0', 10);
      localStorage.setItem(key, count + 1);
      if (action === 'download') setDownloadCount(count + 1);
    }
  };

  const fetchDownloadCount = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}analytics/form-analytics`);
      setDownloadCount(res.data.downloadCount);
    } catch {
      setDownloadCount(parseInt(localStorage.getItem('jobForm_download_count') || '0', 10));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => { fetchDownloadCount(); }, []);

  const generatePdfBlob = () => {
    const el = printableRef.current;
    if (!el) throw new Error('Printable element not found');
    return html2pdf().set(getPdfOptions()).from(el).toPdf().output('blob');
  };

  const handleDownload = async () => {
    if (!isFormComplete) { alert(`Please fill all required fields before downloading.`); return; }
    setIsGenerating(true);
    try {
      trackEvent('download');
      await html2pdf().set(getPdfOptions()).from(printableRef.current).save();
    } catch (e) {
      alert('Failed to generate PDF. Please try again.');
    } finally {
      setIsGenerating(false);
    }
  };

  const handlePrint = async () => {
    if (!isFormComplete) { alert('Please complete all required fields before printing.'); return; }
    setIsGenerating(true);
    try {
      trackEvent('print');
      const blob = await generatePdfBlob();
      const url = URL.createObjectURL(blob);
      const win = window.open(url);
      if (win) {
        win.onload = () => { win.print(); URL.revokeObjectURL(url); };
      }
    } catch {
      alert('Failed to generate printable PDF.');
    } finally {
      setIsGenerating(false);
    }
  };

  const handleShare = async () => {
    if (!isFormComplete) { alert('Please fill all required fields before sharing.'); return; }
    if (!navigator.share) { alert('Web Share API not supported. Please download and share manually.'); return; }
    setIsGenerating(true);
    try {
      const blob = await generatePdfBlob();
      const file = new File([blob], 'Job_Application_Form.pdf', { type: 'application/pdf' });
      trackEvent('share');
      await navigator.share({ title: 'Job Application Form', text: 'Here is my completed job application form.', files: [file] });
    } catch { alert('Failed to share. Please download and share manually.'); }
    finally { setIsGenerating(false); }
  };

  const handleSendToWhatsApp = async () => {
    if (!isFormComplete) { alert('Please complete all required fields before sending.'); return; }
    if (!whatsappNumber) { alert('Please enter a valid WhatsApp number.'); return; }
    const cleaned = whatsappNumber.replace(/\D/g, '');
    const msg = encodeURIComponent('Please find my job application form attached.');
    trackEvent('whatsapp');
    await handleDownload();
    window.open(`https://wa.me/${cleaned}?text=${msg}`, '_blank');
  };

  // ── Input Helpers ────────────────────────────────────────────────────────
  const inputCls = 'mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm';
  const labelCls = 'block text-xs font-semibold text-gray-500 uppercase tracking-wide';

  const Field = ({ label, name, type = 'text', rows, options, required }) => {
    const isMissing = required && missingFields.includes(name);
    const cls = `${inputCls} ${isMissing ? 'border-red-400 bg-red-50' : ''}`;
    return (
      <div>
        <label className={labelCls}>{label}{required && <span className="text-red-500 ml-1">*</span>}</label>
        {options ? (
          <select name={name} value={formData[name]} onChange={handleInputChange} className={cls}>
            <option value="">Select</option>
            {options.map(o => <option key={o} value={o}>{o}</option>)}
          </select>
        ) : rows ? (
          <textarea name={name} value={formData[name]} onChange={handleInputChange} className={cls} rows={rows} />
        ) : (
          <input type={type} name={name} value={formData[name]} onChange={handleInputChange} className={cls} />
        )}
        {isMissing && <p className="text-red-500 text-xs mt-1">This field is required</p>}
      </div>
    );
  };

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-70 flex items-center justify-center z-50 p-4">
      {/* Hidden printable document — always mounted so ref is available */}
      <div style={{ position: 'absolute', left: '-9999px', top: 0, width: '794px', background: '#fff' }}>
        <PrintableForm ref={printableRef} formData={formData} />
      </div>

      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl max-h-[92vh] overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 z-10 bg-white border-b border-gray-200 px-8 py-5 flex items-center justify-between rounded-t-2xl">
          <div>
            <h1 className="text-2xl font-extrabold text-gray-900">Job Application Form</h1>
            <p className="text-sm text-gray-500 mt-0.5">
              {isFormComplete
                ? <span className="text-green-600 font-medium">✅ All required fields complete — ready to export</span>
                : <span className="text-amber-600 font-medium">⚠️ {missingFields.length} required field{missingFields.length !== 1 ? 's' : ''} remaining</span>
              }
            </p>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-700 text-3xl font-light leading-none">&times;</button>
        </div>

        {/* Action Bar */}
        <div className="px-8 py-4 bg-gray-50 border-b border-gray-200 flex flex-wrap gap-3 items-center">
          {[
            { label: isGenerating ? 'Generating…' : 'Print', onClick: handlePrint, color: 'bg-emerald-600 hover:bg-emerald-700' },
            { label: isGenerating ? 'Generating…' : 'Download PDF', onClick: handleDownload, color: 'bg-indigo-600 hover:bg-indigo-700' },
            { label: isGenerating ? 'Generating…' : 'Share', onClick: handleShare, color: 'bg-violet-600 hover:bg-violet-700' },
          ].map(({ label, onClick, color }) => (
            <button
              key={label}
              onClick={onClick}
              disabled={!isFormComplete || isGenerating}
              className={`text-white text-sm font-semibold py-2 px-5 rounded-lg transition-colors ${
                isFormComplete && !isGenerating ? color : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              }`}
            >{label}</button>
          ))}
          <div className="flex items-center gap-2 ml-2">
            <input
              type="tel"
              value={whatsappNumber}
              onChange={e => setWhatsappNumber(e.target.value)}
              placeholder="WhatsApp number"
              className="p-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 w-44"
            />
            <button
              onClick={handleSendToWhatsApp}
              disabled={!isFormComplete || !whatsappNumber || isGenerating}
              className={`text-sm font-semibold py-2 px-4 rounded-lg transition-colors ${
                isFormComplete && whatsappNumber && !isGenerating
                  ? 'bg-teal-600 hover:bg-teal-700 text-white'
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              }`}
            >Send via WhatsApp</button>
          </div>
          <span className="ml-auto text-xs text-gray-400">
            {isLoading ? 'Loading…' : `${downloadCount} download${downloadCount !== 1 ? 's' : ''}`}
          </span>
        </div>

        {/* Form Body */}
        <div className="px-8 py-8 space-y-10">

          {/* Position */}
          <section>
            <h2 className="text-base font-bold text-gray-700 uppercase tracking-wider mb-4 pb-2 border-b">Position Applied For</h2>
            <Field label="Position Applied For" name="positionAppliedFor" required />
          </section>

          {/* Personal Details */}
          <section>
            <h2 className="text-base font-bold text-gray-700 uppercase tracking-wider mb-4 pb-2 border-b">Personal Details</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <Field label="Title (Mr/Mrs/Miss/Ms)" name="title" required />
              <Field label="Surname" name="surname" required />
              <Field label="First Name(s)" name="firstName" required />
              <Field label="Other Names" name="otherNames" />
              <div className="md:col-span-2"><Field label="Address" name="address" rows={3} required /></div>
              <Field label="Email Address" name="email" type="email" required />
              <Field label="Phone Number" name="phoneNumber" type="tel" required />
              <div className="md:col-span-2"><Field label="Preferred Contact Method" name="preferredContact" required /></div>
              <div className="md:col-span-2"><Field label="Dates Not Available for Interview" name="unavailableDates" rows={2} /></div>
              <Field label="Eligible for Employment in Nigeria?" name="eligibleNigeria" options={['YES', 'NO']} required />
              <Field label="Criminal Convictions (Unspent)?" name="criminalConvictions" options={['YES', 'NO']} required />
              <div className="md:col-span-2"><Field label="Documents for Eligibility" name="eligibilityDocuments" rows={2} /></div>
              <div className="md:col-span-2"><Field label="Details of Unspent Convictions (if applicable)" name="unspentConvictionsDetails" rows={2} /></div>
            </div>
          </section>

          {/* Current Employer */}
          <section>
            <h2 className="text-base font-bold text-gray-700 uppercase tracking-wider mb-4 pb-2 border-b">Current / Previous Employer</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <Field label="Company Name" name="currentEmployerName" required />
              <Field label="Nature of Business" name="natureOfBusiness" />
              <div className="md:col-span-2"><Field label="Employer Address" name="currentEmployerAddress" rows={2} /></div>
              <Field label="Job Title" name="jobTitle" required />
              <Field label="Notice Period Required" name="noticePeriod" />
              <Field label="Date Joined Organisation" name="dateJoined" type="date" required />
              <Field label="Date Started Current Position" name="dateStartedCurrent" type="date" />
              <Field label="Current Salary / Salary When Left" name="currentSalary" required />
              <div className="md:col-span-2"><Field label="Main Tasks and Responsibilities" name="mainTasks" rows={4} required /></div>
              <div className="md:col-span-2"><Field label="Reason for Leaving (if no longer employed)" name="reasonForLeaving" rows={2} /></div>
            </div>
          </section>

          {/* Employment History */}
          <section>
            <h2 className="text-base font-bold text-gray-700 uppercase tracking-wider mb-1 pb-2 border-b">Employment History</h2>
            <p className="text-xs text-gray-500 mb-4">List in chronological order, most recent first.</p>
            {formData.employmentHistory.map((entry, idx) => (
              <div key={idx} className="bg-gray-50 border border-gray-200 rounded-xl p-5 mb-4">
                <p className="text-xs font-bold text-gray-500 uppercase mb-3">Entry {idx + 1}</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className={labelCls}>Employer Name</label>
                    <input type="text" value={entry.employerName}
                      onChange={e => handleEmploymentHistoryChange(idx, 'employerName', e.target.value)}
                      className={inputCls} />
                  </div>
                  <div>
                    <label className={labelCls}>Employer Address</label>
                    <input type="text" value={entry.employerAddress}
                      onChange={e => handleEmploymentHistoryChange(idx, 'employerAddress', e.target.value)}
                      className={inputCls} />
                  </div>
                  <div>
                    <label className={labelCls}>Type of Business</label>
                    <input type="text" value={entry.businessType}
                      onChange={e => handleEmploymentHistoryChange(idx, 'businessType', e.target.value)}
                      className={inputCls} />
                  </div>
                  <div>
                    <label className={labelCls}>Dates of Employment</label>
                    <input type="text" placeholder="e.g. Jan 2020 – Mar 2022" value={entry.dates}
                      onChange={e => handleEmploymentHistoryChange(idx, 'dates', e.target.value)}
                      className={inputCls} />
                  </div>
                  <div>
                    <label className={labelCls}>Job Title / Role</label>
                    <input type="text" value={entry.jobTitle}
                      onChange={e => handleEmploymentHistoryChange(idx, 'jobTitle', e.target.value)}
                      className={inputCls} />
                  </div>
                  <div>
                    <label className={labelCls}>Reason for Leaving</label>
                    <input type="text" value={entry.reasonForLeaving}
                      onChange={e => handleEmploymentHistoryChange(idx, 'reasonForLeaving', e.target.value)}
                      className={inputCls} />
                  </div>
                </div>
              </div>
            ))}
            <button type="button" onClick={addEmploymentEntry}
              className="mt-1 bg-gray-700 hover:bg-gray-800 text-white text-sm font-semibold py-2 px-5 rounded-lg transition-colors">
              + Add Entry
            </button>
          </section>

          {/* Education */}
          <section>
            <h2 className="text-base font-bold text-gray-700 uppercase tracking-wider mb-4 pb-2 border-b">Education and Training</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              <Field label="Secondary School Attended" name="secondarySchool" required />
              <Field label="Examinations Passed" name="secondaryExams" required />
              <Field label="Grades" name="secondaryGrades" />
              <div className="md:col-span-3"><Field label="Further and Higher Education" name="furtherEducation" rows={3} required /></div>
              <Field label="Professional Organisation" name="professionalOrg" />
              <Field label="Grade of Membership" name="gradeOfMembership" />
              <div className="md:col-span-3"><Field label="Job-Related Training" name="jobTraining" rows={3} /></div>
            </div>
          </section>

          {/* Skills */}
          <section>
            <h2 className="text-base font-bold text-gray-700 uppercase tracking-wider mb-4 pb-2 border-b">Skills, Abilities and Supporting Information</h2>
            <Field label="Provide evidence of skills, knowledge, and experience relevant to this role" name="skillsInfo" rows={6} required />
          </section>

          {/* References */}
          <section>
            <h2 className="text-base font-bold text-gray-700 uppercase tracking-wider mb-1 pb-2 border-b">References</h2>
            <p className="text-xs text-gray-500 mb-5">Provide details of two referees. We will only contact them with your prior agreement.</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {[1, 2].map(n => (
                <div key={n} className="space-y-3">
                  <h3 className="font-bold text-sm text-gray-700">Referee {n}</h3>
                  {['Name', 'Company', 'Job Title', 'Relationship', 'Phone', 'Email'].map(f => {
                    const fname = `ref${n}${f}`;
                    const required = ['Name', 'Company', 'JobTitle', 'Phone', 'Email'].includes(f);
                    const isMissing = required && missingFields.includes(fname);
                    return (
                      <div key={f}>
                        <label className={labelCls}>{f}{required && <span className="text-red-500 ml-1">*</span>}</label>
                        <input
                          type={f === 'Email' ? 'email' : f === 'Phone' ? 'tel' : 'text'}
                          name={fname}
                          value={formData[fname]}
                          onChange={handleInputChange}
                          className={`${inputCls} ${isMissing ? 'border-red-400 bg-red-50' : ''}`}
                        />
                        {isMissing && <p className="text-red-500 text-xs mt-1">Required</p>}
                      </div>
                    );
                  })}
                  <div>
                    <label className={labelCls}>Address</label>
                    <textarea name={`ref${n}Address`} value={formData[`ref${n}Address`]}
                      onChange={handleInputChange} className={inputCls} rows={2} />
                  </div>
                  <div>
                    <label className={labelCls}>Fax</label>
                    <input type="text" name={`ref${n}Fax`} value={formData[`ref${n}Fax`]}
                      onChange={handleInputChange} className={inputCls} />
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Declaration */}
          <section>
            <h2 className="text-base font-bold text-gray-700 uppercase tracking-wider mb-4 pb-2 border-b">Personal Declaration</h2>
            <p className="text-sm text-gray-600 bg-gray-50 border border-gray-200 rounded-lg p-4 mb-5 leading-relaxed">
              I confirm that, to the best of my knowledge, all the details I have given on this form are complete and true.
              I understand that if I give any false or misleading information, and/or I am unable to provide specifically
              requested details (of qualifications etc), it may lead to my dismissal (if I have already been given the job).
              I understand that any job offer depends on the supply of satisfactory references, evidence that I am eligible
              to work in Nigeria and sight of original certificates, as detailed in my application.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <Field label="Signature (type your full name)" name="signature" required />
              <Field label="Date" name="date" type="date" required />
            </div>
          </section>

        </div>
      </div>
    </div>
  );
};

export default JobApplicationFormShareable;